/**
 * handleSelectSection.js
 *
 * Copyright (c) apploft. GmbH
 */

import {http, URL, Path, APIDefinition} from 'apploft-cloud-client';
import {presentingForm, fetchingItems} from '../ContentStateSymbol';
import {failedItemsRequest, itemsReceived} from '../ContentEventSymbol';
import {stringMatching} from 'apploft-cloud-forms';
// @ts-ignore
import strings from '../../../assets/strings.json';

export default function handleSelectSection({section, api, dispatch}) {
  const paths = APIDefinition.pathsMatching(section, api);
  const url = URL.createGetUrl({api, paths});

  if (url) {
    const authorization = APIDefinition.keyAdminAuth(api);
    const controller = new AbortController();
    const {signal} = controller;
    const {get} = http;

    get({url, authorization, signal})
      .then(items => {
        if (!Array.isArray(items)) {
          throw new Error('not an Array');
        }

        dispatch({event: itemsReceived, payload: {items, section, api}});
      })
      .catch(error => {
        if (error instanceof DOMException) {
          console.assert(
            error.message === 'The user aborted a request.',
            `unexpected error: ${error.message}`,
          );

          return;
        }

        dispatch({event: failedItemsRequest, payload: {error, section, api}});
      });

    return {
      state: fetchingItems,
      data: `${stringMatching(strings, 'Loading Elements')} (${stringMatching(
        strings,
        section.name,
      )}).`,
      controller,
    };
  } else {
    const widgetProps = Path.findPostProps(paths);

    return {state: presentingForm, data: {widgetProps, section, api}};
  }
}
